import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 订单管理 — 订单为流水数据, 不允许新建/删除, 仅查看 + 改备注/状态.
 */
export const ordersConfig: CrudConfig = {
  resource: 'orders',
  title: '订单管理',
  rowKey: 'id',
  searchFields: ['order_no', 'status', 'product_type'],
  disableCreate: true,
  disableDelete: true,
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    { name: 'order_no', label: '订单号', type: 'text', copyable: true, width: 180, readonly: true },
    { name: 'user_email', label: '用户邮箱', type: 'readonly', width: 200, ellipsis: true, hideInForm: true, readonly: true },
    { name: 'product_name', label: '产品', type: 'readonly', ellipsis: true, hideInForm: true, readonly: true },
    {
      name: 'product_type',
      label: '产品类型',
      type: 'select',
      width: 120,
      readonly: true,
      options: [
        { label: '订阅', value: 'SUBSCRIPTION', color: 'blue' },
        { label: '模拟题', value: 'MOCK_EXAM', color: 'cyan' },
        { label: '正式考试', value: 'EXAM', color: 'purple' },
        { label: '课程', value: 'COURSE', color: 'gold' },
        { label: '证书', value: 'CERTIFICATE', color: 'green' },
      ],
    },
    { name: 'amount', label: '金额', type: 'number', width: 120, readonly: true },
    { name: 'currency', label: '币种', type: 'text', width: 80, readonly: true },
    {
      name: 'status',
      label: '状态',
      type: 'select',
      width: 120,
      options: [
        { label: '待支付', value: 'PENDING', status: 'Default' },
        { label: '已支付', value: 'PAID', status: 'Success', color: 'green' },
        { label: '已取消', value: 'CANCELLED', status: 'Error', color: 'red' },
        { label: '已退款', value: 'REFUNDED', status: 'Warning', color: 'orange' },
        { label: '已过期', value: 'EXPIRED', status: 'Default' },
      ],
    },
    { name: 'remark', label: '备注', type: 'textarea', hideInTable: true },
    { name: 'created_at', label: '创建时间', type: 'datetime', width: 180, readonly: true, hideInForm: true },
    { name: 'paid_at', label: '支付时间', type: 'datetime', width: 180, readonly: true, hideInForm: true, hideInTable: true },
  ],
};
